<script setup lang="ts">
import { inject, watch, ref } from 'vue';

import type { Viewer, Nullable, Extension } from '@immersive-tech/viewer-engine';
import type { Ref } from 'vue';
import type { Perspectives } from '@/viewerExtensions';

const viewer = inject('viewer') as Ref<Nullable<Viewer>>;
const perspectivesExtension = ref(viewer.value?.extensions.get('Perspectives') as Nullable<Extension<Perspectives>>);

const resetView = () => {
  perspectivesExtension.value?.resetView();
};

const viewerWatcher = (newValue: Nullable<Viewer>) => {
  if (!newValue) return;

  perspectivesExtension.value = newValue.extensions.get('Perspectives') as Extension<Perspectives>;
};

watch(viewer, viewerWatcher);
</script>

<template>
  <button v-if="viewer" type="button" class="text-white bg-lime-600 px-2 py-1 text-sm rounded-sm" @click="resetView">
    <span>Reset View</span>
  </button>
</template>
